// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"5240fe71","358":"4efc6e18","438":"7fd8b04f","631":"0f2e9ea3","646":"74616a4c","664":"2b820c3c","831":"acdb818c","931":"d9d8b0ee"}[chunkId] + ".chunk.js";
};